"use client";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { SnackBarV2 } from "@website/ui/snackbar-v2";
import { deepCompare } from "@website/utils/deep-compare";
import { AnimatedTelesales } from "@website/widget/telesales/animatedTelesale";
import { useTelesales } from "@website/widget/telesales/hooks";
import { TelesalesForm } from "@website/widget/telesales/telesales-form";
import { TelesalesPropertiesType } from "@website/widget/telesales/types";
import { memo } from "react";

const Component = ({
  isPadding = false,
  requestData,
  storageKey,
  reasons,
  onButtonClick,
  onSuccess,
  description,
  showAnimatedMobileButton,
  className
}: TelesalesPropertiesType) => {
  const {
    isOpenModal,
    setIsOpenModal,
    handleOpenModal,
    isSubmitBefore,
    onSubmitSuccess,
    onCloseSnackbar,
    snackbar
  } = useTelesales(storageKey, requestData.app);
  return (
    <>
      <div className={showAnimatedMobileButton ? "max-md:hidden" : ""}>
        <Button
          StartIcon={
            <MaterialIcon
              className="absolute right-3 top-2 text-2xl"
              name="phone_enabled"
            />
          }
          children="رزرو تلفنی"
          className={`shadow-8 !fixed bottom-6 ${
            isPadding ? "max-lg:bottom-24 max-md:bottom-36" : ""
          } right-6 z-[12] gap-3 ${className ?? ""}`}
          color="secondary"
          onClick={() => {
            onButtonClick?.();
            handleOpenModal();
          }}
          size="large"
          variant="round"
        />
      </div>
      {showAnimatedMobileButton && (
        <div className="md:hidden">
          <AnimatedTelesales
            onClick={() => {
              onButtonClick?.();
              handleOpenModal();
            }}
          />
        </div>
      )}
      <Modal
        className="flex gap-6"
        dialogClassName="lg:max-w-[448px]"
        headerStyle="text-headline-6 m-0"
        mobileHeight="auto"
        onClose={() => setIsOpenModal(false)}
        open={isOpenModal}
        showCloseButton
        title="ثبت درخواست رزرو تلفنی"
      >
        <TelesalesForm
          description={description}
          isSubmitBefore={isSubmitBefore}
          onClose={() => setIsOpenModal(false)}
          onSubmitSuccess={onSubmitSuccess}
          onSuccess={onSuccess}
          reasons={reasons}
          requestData={requestData}
          storageKey={storageKey}
        />
      </Modal>

      <SnackBarV2 {...snackbar} onClose={onCloseSnackbar} />
    </>
  );
};
export const Telesales = memo(Component, deepCompare);
